import SectionIntro from "./SectionIntro";
import { hotRank } from "@/mocks/softwareData";

const medal = ["bg-primary-500 text-background-50", "bg-secondary-500 text-background-50", "bg-accent-500 text-background-50"];

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionIntro
          eyebrow="TOP · 热度即正义"
          title="本周下载热榜 TOP 10"
          desc="按本周下载热度实时加权排序，榜首更换会第一时间置顶提醒。"
          center
        />

        {/* 榜单列表 */}
        <div className="mx-auto mt-8 max-w-4xl overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <ol className="divide-y divide-background-200/70">
            {hotRank.map((item) => (
              <li
                key={item.rank}
                className={`flex items-center gap-3 px-3 py-3.5 transition-colors hover:bg-primary-50 md:gap-4 md:px-5 ${
                  item.rank <= 3 ? "bg-background-100/60" : ""
                }`}
              >
                {/* 名次 */}
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold ${
                    item.rank <= 3 ? medal[item.rank - 1] : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>

                {/* 主体 */}
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <span className="font-display text-base font-bold text-foreground-950">{item.name}</span>
                    <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-xs font-semibold text-secondary-700">
                      {item.version}
                    </span>
                    {item.status === "hot" && (
                      <span className="flex items-center gap-0.5 whitespace-nowrap rounded bg-primary-100 px-1.5 py-0.5 text-xs font-semibold text-primary-600">
                        <i className="ri-fire-fill"></i>热
                      </span>
                    )}
                    {item.status === "new" && (
                      <span className="flex items-center gap-0.5 whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 text-xs font-semibold text-accent-700">
                        <i className="ri-sparkling-2-fill"></i>新版
                      </span>
                    )}
                  </div>
                  <p className="mt-1 hidden truncate text-sm text-foreground-600 sm:block">{item.summary}</p>
                </div>

                {/* 右信息 */}
                <div className="hidden shrink-0 flex-col items-end gap-1 md:flex">
                  <span className="text-xs text-foreground-400">{item.tag}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-secondary-600">
                    <i className="ri-flashlight-fill"></i>
                    {item.heat}
                  </span>
                </div>
                <div className="hidden shrink-0 items-center gap-1 text-xs font-semibold text-secondary-600 lg:flex">
                  <i className="ri-star-fill"></i>
                  {item.score}
                </div>
                <a
                  href="#guide"
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
                  aria-label={`下载 ${item.name}`}
                >
                  <i className="ri-download-2-line"></i>
                </a>
              </li>
            ))}
          </ol>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-400">
          榜单数据每日 0 点更新 · 点击右侧下载按钮进入对应安装通道
        </p>
      </div>
    </section>
  );
}